import React from "react";
import styles from "../../pages/styles";

const PricingClasses = ({ title, desc }) => {
  const pricingData = [
    {
      title: "Discounted Commitment Plans",
      startingPrice: "$240/month",
      features: [
        "Discounted for commitment",
        "Weekly 1:1 Classes with an Expert",
        "1:1 STEM through Game Development",
        "Includes homework & software fees",
      ],
    },
    {
      title: "Month-to-Month Plans",
      startingPrice: "$260/month",
      features: [
        "Flexible scheduling",
        "Weekly 1:1 Classes with an Expert",
        "No long-term commitment",
        "Includes homework & software fees",
      ],
    },
  ];

  return (
    <div className="py-8 md:py-10 px-4 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-4xl mx-auto text-center mb-6 md:mb-8 px-2 md:px-4">
          <h2 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>{title}</h2>
          <p className={`${styles.paragraph}`}>{desc}</p>
        </div>
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {pricingData.map((plan, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl border-2 border-gray-200 hover:border-orangeprimary p-6 md:p-8 flex flex-col justify-between transition-all"
            >
              <div>
                <h3 className={`${styles.headingdark} text-center mb-4`}>
                  {plan.title}
                </h3>
                <div className="text-center mb-6">
                  <p className="text-xs text-gray-500 mb-1">Starting at</p>
                  <span className="text-3xl font-bold text-darkprimary">
                    {plan.startingPrice}
                  </span>
                </div>
                <ul className="space-y-2 mb-6">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-orangeprimary mr-2">✓</span>
                      <span className={`${styles.paragraph} text-gray-700 text-sm`}>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="text-center mt-4">
                <a
                  href="/pages/freetrial"
                  className="bg-pinkprimary text-white px-6 py-3 rounded-full inline-block hover:bg-orangeprimary transition-colors font-semibold"
                >
                  Schedule Trial Class
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingClasses;
